<template>
  <a-spin :spinning="loading">
    <a-breadcrumb class="m-b-md">
      <a-breadcrumb-item>系统管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link to="/systemSetting/manage/rolePower">角色权限</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>菜单权限{{ name ? `：${name}` : '' }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div>
      <a-button size="small" type="primary" @click="$router.replace('/systemSetting/manage/rolePower')">返回</a-button>
      <a-button size="small" class="gap-10" type="primary" @click="submit">保存</a-button>
    </div>
    <a-tree checkable defaultExpandAll v-if="list.length > 0" v-model="checkedKeys">
      <a-tree-node v-for="v in list" :key="v.id" :title="v.name">
        <a-tree-node v-for="children in v.children" :title="children.name" :key="children.id">
          <a-tree-node checked v-for="sub in children.children" :title="sub.name" :key="sub.id">
            <a-tree-node checked v-for="subChildren in sub.children" :title="subChildren.name" :key="subChildren.id">
              <a-tree-node checked v-for="last in subChildren.children" :title="last.name" :key="last.id" />
            </a-tree-node>
          </a-tree-node>
        </a-tree-node>
      </a-tree-node>
    </a-tree>
  </a-spin>
</template>
<script>
import { menuList } from '@/api/systemMenuSetting.js';
import { roleMenuPermissionList, setRoleMenuPermission } from '@/api/systemRoleSetting.js';
export default {
  data() {
    return {
      loading: false,
      list: [],
      keys: [],
      checkedKeys: []
    };
  },
  computed: {
    name() {
      return this.$route.query.name;
    },
    roleId() {
      return this.$route.query.id;
    }
  },
  methods: {
    getList() {
      this.loading = true;
      menuList().then(res => {
        this.list = res.data;
        this.list.forEach(e => {
          this.isChecked(e);
        });
        this.loading = false;
      });
    },
    getDefaultKeys() {
      roleMenuPermissionList(this.roleId).then(res => {
        this.keys = res.data;
        this.getList();
      });
    },
    async handleChange(e) {
      const query = {
        roleId: this.roleId,
        permissionIds: e.join(',')
      };
      if (query.permissionIds === '') {
        this.$message.error('权限不可为空');
        return;
      }
      this.loading = true;
      const res = await setRoleMenuPermission(query);
      if (res.code) {
        this.$message.success('success');
        this.loading = false;
      }
    },
    submit() {
      this.handleChange(this.checkedKeys);
    },
    isChecked(item) {
      if (item.children) {
        item.children.forEach(e => {
          this.isChecked(e);
        });
      } else {
        if (this.keys && this.keys.indexOf(item.id) !== -1) {
          this.checkedKeys.push(item.id);
        }
      }
    }
  },
  created() {
    this.getDefaultKeys();
  }
};
</script>
